import {Column, Entity, PrimaryColumn} from "typeorm";

@Entity("comportamento")
export class Comportamento  {
  @PrimaryColumn()
  id?:string
  @Column()
  nome?: string
  @Column()
  excluido?: boolean
}
